import {ActionBarAppearance, ActionBarConfig, ActionBarDefaults} from '@edifecs/fp-ui-lib';
import {Injectable, Provider} from '@angular/core';
import {AppConfigService} from './AppConfigService';

/**
 * Provides settings for action bar component appearance.
 */
@Injectable({providedIn: 'root'})
export class ActionBarDefaultsService extends ActionBarDefaults {
    /**
     * Provider for base class.
     */
    public static readonly BASE_PROVIDER: Provider = {
        provide: ActionBarDefaults,
        useExisting: ActionBarDefaultsService
    };

    /**
     * Constructor
     * @param appConfig App config
     */
    constructor(private readonly appConfig: AppConfigService) {
        super();
    }

    /**
     * Actionbar default configuration
     */
    get config(): ActionBarConfig | undefined {
        // no global settings yet
        return undefined;
    }

    /**
     * Actionbar default appearance
     */
    get appearance(): ActionBarAppearance | undefined {
        // app wide appearance
        return this.appConfig.actionbarAppearance;
    }

}
